import ServiceCard from '../components/ServiceCard';
import './Services.css';

const Services = () => {
  const servicesData = [
    {
      number: '01',
      title: 'TAILORING',
      description: 'Ready-to-wear clothes, shirred dresses and tops for women, suits, custom-made clothes and uniforms of all types—expertly crafted in our Lilongwe studio.',
      image: '/images/products/english-satin.jpeg'
    },
    {
      number: '02',
      title: 'SCREEN PRINTING',
      description: 'Pompano Screen Printing delivers vibrant, lasting prints on uniforms, t-shirts, and clothes. From corporate branding to event wear, we ensure bold colors, professional quality, and creative designs that stand out.',
      image: '/images/products/apron-set.jpeg'
    },
    {
      number: '03',
      title: 'T-SHIRT PRINTING',
      description: 'Custom t-shirt printing for individuals, teams, schools, and businesses. Choose your design, colors, and quantity—we handle the rest with high-quality ink and fabric for results that last.',
      image: '/images/products/throw-pillows.jpeg'
    },
    {
      number: '04',
      title: 'EMBROIDERY',
      description: 'Pompano Embroidery transforms uniforms and clothes with precision stitching, adding logos, names, and creative designs. Durable, professional, and stylish solutions for businesses, schools, events, and personal wear.',
      image: '/images/products/congo-chitenje.jpeg'
    },
    {
      number: '05',
      title: 'GOWNS',
      description: 'Barrister gowns and graduation gowns made to the highest standards. Whether for your big day or professional ceremony, we craft dignified, well-fitted gowns you will be proud to wear.',
      image: '/images/products/cotton-kente.jpeg'
    },
    {
      number: '06',
      title: 'REUSABLE PADS',
      description: 'Eco-friendly, washable reusable pads crafted from high-quality, skin-safe fabrics. Comfortable, sustainable, and affordable—a thoughtful choice for everyday health and the environment.',
      image: '/images/products/batiki.jpeg'
    }
  ];

  return (
    <section className="section services-page">
      <div className="container">
        <h1 className="section-title">Our Services</h1>
        <p className="services-page-intro">
          From bespoke tailoring to screen printing, embroidery, and eco-friendly products—Pompano offers a full range of quality services in Lilongwe.
        </p>
        <div className="services-grid">
          {servicesData.map(service => (
            <ServiceCard key={service.number} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
